import { useEffect, useRef, useState } from "react";
import "./language-picker.css";
import { flagSrc, LOCALES, useLang, useT } from "../i18n/index.tsx";

/** Flag + language name; opens a two-column list. `compact` shows the flag only (topbar on phones). */
export function LanguagePicker({ compact = false, align = "end" }: { compact?: boolean; align?: "start" | "end" }) {
  const { lang, setLang } = useLang();
  const t = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const current = LOCALES.find((l) => l.code === lang) ?? LOCALES[0];

  useEffect(() => {
    if (!open) return;
    const onDown = (e: PointerEvent) => !ref.current?.contains(e.target as Node) && setOpen(false);
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setOpen(false);
    document.addEventListener("pointerdown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("pointerdown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div className={`lang-picker ${align}`} ref={ref}>
      <button type="button" className="lang-btn" onClick={() => setOpen(!open)} aria-haspopup="listbox" aria-expanded={open} aria-label={t.shell.language}>
        <img className="flag" src={flagSrc(current.code)} alt="" width={18} height={18} />
        {!compact && <span>{current.label}</span>}
      </button>
      {open && (
        <ul className="lang-list" role="listbox" aria-label={t.shell.language}>
          {LOCALES.map((l) => (
            <li key={l.code}>
              <button type="button" role="option" aria-selected={l.code === lang} lang={l.html} onClick={() => { setOpen(false); if (l.code !== lang) setLang(l.code); }}>
                <img className="flag" src={flagSrc(l.code)} alt="" width={18} height={18} />
                {l.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
